/**
 * Un usuario no "pertenece" a un rancho como un lote: tiene una lista `allowedRanchos`
 * y, si está vacía o nula, acceso a TODOS. Por eso filtrar Usuarios por el rancho activo
 * es "quién tiene acceso a este rancho": los restringidos a él MÁS los de acceso total
 * (si se ocultaran estos, un admin con acceso total desaparecería de la lista).
 * Sin rancho activo ("Todos los ranchos") se ven todos. (Hallazgo 11 del QA manual.)
 */
export function userHasRanchoAccess(
  user: { allowedRanchos?: string[] | null },
  activeRanchoId: string | null | undefined,
): boolean {
  if (!activeRanchoId) return true;
  const allowed = user.allowedRanchos;
  if (!allowed || allowed.length === 0) return true;
  return allowed.includes(activeRanchoId);
}

/** true si el usuario tiene acceso a todos los ranchos (sin restricción). */
export function userHasAllRanchos(user: { allowedRanchos?: string[] | null }): boolean {
  return !user.allowedRanchos || user.allowedRanchos.length === 0;
}
